module.exports = __webpack_public_path__ + "img/Strategising for Mumbais Urban Transformation using the Power of Narrative.73fabc23.jpg";